import styled, { css } from 'styled-components';

import { Flex } from '@/components/base';

import type { NumberT } from './types';

const IncrementBadgeWrapper = styled(Flex)<{ amountType: NumberT }>`
  border-radius: 6px;
  width: 66px;
  height: 24px;
  text-align: center;

  ${({ amountType, theme }) => {
    switch (amountType) {
      case 'zero':
        return css`
          background-color: ${theme.colors.gray300};
          color: ${theme.colors.gray700};
        `;

      case 'positive':
        return css`
          background-color: ${theme.colors.green(0.1)};
          color: ${theme.colors.green500};
        `;

      case 'negative':
        return css`
          background-color: ${theme.colors.red(0.15)};
          color: ${theme.colors.red600};
        `;

      case 'new':
        return css`
          background-color: ${theme.colors.yellow(0.15)};
          color: ${theme.colors.yellow500};
        `;
    }
  }}
`;

const IncrementBadgeStyle = {
  IncrementBadgeWrapper,
};

export default IncrementBadgeStyle;
